import script from "./HealthInfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./HealthInfoCard.vue?vue&type=script&setup=true&lang=js"

import "./HealthInfoCard.vue?vue&type=style&index=0&id=273400dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-273400dc"]])

export default __exports__